var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_radial_137_8)",
    fillOpacity: 0.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78054 12.439H13.9025C14.3366 12.439 14.761 12.3103 15.122 12.0691C15.483 11.8279 15.7644 11.485 15.9305 11.0839C16.0967 10.6828 16.1401 10.2415 16.0554 9.81564C15.9707 9.38983 15.7617 8.9987 15.4547 8.6917C15.1477 8.38471 14.7565 8.17565 14.3307 8.09095C13.9049 8.00625 13.4636 8.04972 13.0624 8.21586C12.6613 8.38201 12.3185 8.66336 12.0773 9.02435C11.8361 9.38533 11.7074 9.80974 11.7074 10.2439M9.51224 18.2927H17.561C17.9952 18.2927 18.4196 18.4214 18.7806 18.6626C19.1416 18.9038 19.4229 19.2466 19.5891 19.6478C19.7552 20.0489 19.7987 20.4902 19.714 20.916C19.6293 21.3419 19.4202 21.733 19.1132 22.04C18.8062 22.347 18.4151 22.556 17.9893 22.6407C17.5635 22.7254 17.1221 22.682 16.721 22.5158C16.3199 22.3497 15.977 22.0683 15.7358 21.7073C15.4946 21.3463 15.3659 20.9219 15.3659 20.4878M8.04883 15.3658H20.4879C20.922 15.3658 21.3464 15.2371 21.7074 14.9959C22.0684 14.7547 22.3497 14.4119 22.5159 14.0108C22.682 13.6096 22.7255 13.1683 22.6408 12.7425C22.5561 12.3167 22.347 11.9255 22.04 11.6185C21.733 11.3115 21.3419 11.1025 20.9161 11.0178C20.4903 10.9331 20.0489 10.9765 19.6478 11.1427C19.2467 11.3088 18.9039 11.5902 18.6627 11.9512C18.4215 12.3122 18.2927 12.7366 18.2927 13.1707",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_137_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 15) rotate(90) scale(15)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/Air.aff5eee9f4ef1d45913dbf5faef4bc0d.svg";
export { ForwardRef as ReactComponent };